import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../services/common.service';
import { CSharpRequestService } from '../services/csharp-request.service';
import { TitleComponent } from '../title/title.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-offline-no-data',
    templateUrl: './offline-no-data.component.html',
    styleUrls: ['./offline-no-data.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TitleComponent, NgClass]
})
export class OfflineNoDataComponent implements OnInit {
  @Input() textLineTop = '';
  @Input() textLineBottom = '';
  @Input() imageAltText = '';
  ShowOfflineNotSupportedPage = false;

  constructor(public _ts: TranslateService, public _cs: CommonService, private csharpService: CSharpRequestService) { }

  ngOnInit() {
    this.ShowOfflineNotSupportedPage = this.csharpService.AppVersion != null ? true : false;
    const offlineDetails = this._ts.instant('offline');
    this.textLineTop = offlineDetails.YouAreOffline;
    this.textLineBottom = offlineDetails.OfflineText;
    this.imageAltText = offlineDetails.OfflineNoDataImage;
  }
}
